var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2710_4933)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.526 15.418a.75.75 0 011.056 1.056l-.052.056L19.06 18l1.47 1.47.052.056a.75.75 0 01-1.056 1.056l-.056-.052L18 19.06l-1.47 1.47-.056.052a.75.75 0 01-1.056-1.056l.052-.056L16.94 18l-1.47-1.47-.052-.056a.75.75 0 011.056-1.056l.056.052L18 16.94l1.47-1.47.056-.052z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 12a6 6 0 110 12 6 6 0 010-12zm0 1.5a4.5 4.5 0 100 9 4.5 4.5 0 000-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.212 13.129a7.505 7.505 0 00-1.01 1.521c-2.66.16-4.188 1.117-5.105 2.13-.793.873-1.216 1.886-1.442 2.72h5.908c.106.522.267 1.024.475 1.5H3.912l-.102-.005c-.503-.051-.882-.477-.798-.988C3.36 17.89 4.93 13.125 12 13.125l.212.004z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.233 3.006c2.401.12 4.311 2.086 4.311 4.494l-.006.231C16.416 10.11 14.431 12 12 12l-.233-.006c-2.401-.12-4.31-2.086-4.31-4.494C7.456 5.015 9.49 3 12 3l.233.006zM12 4.5c-1.695 0-3.044 1.357-3.044 3s1.35 3 3.044 3c1.695 0 3.044-1.357 3.044-3s-1.35-3-3.044-3z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2710_4933"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
}
SvgCloseAccount.displayName = 'CloseAccount';
export default SvgCloseAccount;